<template>
    <div>
        <!-- FASE 4 / BLOCO AE — CI 4, 5, 7, 9, 10, 11, 12, 15 -->

        <el-row :gutter="10" class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="16" :md="16">
                <el-alert type="info" :closable="false" show-icon
                          title="Grupos de trabalho organizam o acesso e a alçada das tarefas."
                          description="Quem é membro de um grupo alcança também as tarefas dos subgrupos dele. O contrário não vale.">
                </el-alert>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                <el-button type="primary" icon="el-icon-plus" @click="abrirNovo(null)">NOVO GRUPO</el-button>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :xs="24" :sm="12" :md="12">
                <strong class="rotulo">Hierarquia</strong>
                <div class="painel" v-loading="!statusArvore">
                    <el-tree :data="arvore" node-key="id" :props="propsArvore"
                             default-expand-all :expand-on-click-node="false"
                             @node-click="selecionar">
                        <span class="no" slot-scope="{ node, data }">
                            <span :class="{ inativo: !data.ativo }">
                                <i class="el-icon-s-custom"></i>
                                {{ data.nome }}
                                <el-tag v-if="data.instituicao_id === null" size="mini" type="warning">rede</el-tag>
                                <el-tag v-if="!data.ativo" size="mini" type="info">inativo</el-tag>
                            </span>
                            <span class="acoes-no">
                                <el-button type="text" size="mini" @click.stop="abrirNovo(data)">subgrupo</el-button>
                                <el-button class="u-ml-10" type="text" size="mini" @click.stop="renomear(data)">renomear</el-button>
                                <el-button class="u-ml-10" type="text" size="mini" @click.stop="excluir(data)">excluir</el-button>
                            </span>
                        </span>
                    </el-tree>
                    <p v-if="statusArvore && !arvore.length" class="meta">Nenhum grupo cadastrado ainda.</p>
                </div>
            </el-col>

            <el-col :xs="24" :sm="12" :md="12">
                <strong class="rotulo">
                    Membros {{ selecionado ? '— ' + selecionado.nome : '' }}
                </strong>
                <div class="painel">
                    <div v-if="!selecionado" class="meta">Selecione um grupo na hierarquia.</div>

                    <template v-else>
                        <el-row :gutter="10" class="u-mb-10">
                            <el-col :xs="16">
                                <el-select v-model="novoMembro" filterable remote :remote-method="buscarUsuarios"
                                           :loading="buscando" placeholder="Digite o nome" style="width:100%">
                                    <el-option v-for="u in usuarios" :key="u.id"
                                               :label="u.name" :value="u.id"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="8">
                                <el-select v-model="novoPapel" style="width:100%">
                                    <el-option label="Operador"      value="operador"></el-option>
                                    <el-option label="Administrador" value="administrador"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-button type="primary" size="small" icon="el-icon-plus" class="u-mb-10"
                                   @click="adicionarMembro">ADICIONAR MEMBRO</el-button>

                        <table class="table table-striped">
                            <thead>
                                <tr><th>Nome</th><th style="width:120px">Papel</th><th style="width:60px"></th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="m in membros" :key="m.id">
                                    <td>{{ m.name }}</td>
                                    <td>
                                        <el-tag size="mini" :type="m.papel === 'administrador' ? 'success' : 'info'">
                                            {{ m.papel }}
                                        </el-tag>
                                    </td>
                                    <td class="u-text-center">
                                        <el-button type="danger" icon="el-icon-delete" size="mini" plain
                                                   @click="removerMembro(m)"></el-button>
                                    </td>
                                </tr>
                                <tr v-if="!membros.length">
                                    <td colspan="3" class="u-text-center">Nenhum membro.</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
            </el-col>
        </el-row>

        <el-dialog :title="paiNovo ? 'Novo subgrupo de ' + paiNovo.nome : 'Novo grupo'"
                   :visible.sync="dialogNovo" width="440px">
            <el-form label-position="top">
                <el-form-item label="Nome">
                    <el-input v-model="form.nome" maxlength="180"></el-input>
                </el-form-item>
                <el-form-item label="Sigla (opcional)">
                    <el-input v-model="form.sigla" maxlength="30"></el-input>
                </el-form-item>
                <el-form-item v-if="!paiNovo">
                    <el-checkbox v-model="form.da_rede">
                        Grupo da rede (atravessa todas as escolas)
                    </el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogNovo = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarNovo">CRIAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    data: () => ({
        statusArvore: false,
        arvore: [],
        propsArvore: { children: 'filhos', label: 'nome' },
        selecionado: null,
        membros: [],
        usuarios: [],
        novoMembro: '',
        novoPapel: 'operador',
        buscando: false,
        dialogNovo: false,
        paiNovo: null,
        form: { nome: '', sigla: '', da_rede: false }
    }),
    mounted () { this.carregar() },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        instituicaoAtual () {
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            else if (d && d.erro && d.erro.text) msg = d.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregar () {
            this.statusArvore = false
            this.$axios.post(`${this.base()}/api/grupo-trabalho/arvore`, {}, this.auth()).then(r => {
                this.arvore = r.data
                this.statusArvore = true
            }).catch(e => { this.statusArvore = true; this.erro(e) })
        },

        selecionar (data) {
            this.selecionado = data
            this.membros = []
            this.$axios.get(`${this.base()}/api/grupo-trabalho/membros/${data.id}`, this.auth())
                .then(r => { this.membros = r.data })
                .catch(e => { this.erro(e) })
        },

        abrirNovo (pai) {
            this.paiNovo = pai
            this.form = { nome: '', sigla: '', da_rede: false }
            this.dialogNovo = true
        },

        salvarNovo () {
            if (!this.form.nome || !this.form.nome.trim()) {
                window.eventBus.$emit('alert', { msg: 'Informe o nome do grupo.', type: 'warning' })
                return
            }

            const payload = { nome: this.form.nome.trim(), sigla: this.form.sigla }

            if (this.paiNovo) payload.grupo_pai_id = this.paiNovo.id
            else if (this.form.da_rede) payload.da_rede = true
            else payload.instituicao_id = this.instituicaoAtual()

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/grupo-trabalho/store`, payload, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Grupo criado.', type: 'success' })
                this.dialogNovo = false
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        renomear (g) {
            this.$prompt('Novo nome', 'Renomear grupo', {
                confirmButtonText: 'Salvar', cancelButtonText: 'Cancelar', inputValue: g.nome
            }).then(({ value }) => {
                if (!value || !value.trim()) return
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/grupo-trabalho/update/${g.id}`,
                    { nome: value.trim() }, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Grupo renomeado.', type: 'success' })
                    this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        excluir (g) {
            this.$msgbox.confirm(
                'Excluir este grupo? Se ele já participa de tarefas, será apenas inativado.', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/grupo-trabalho/remover/${g.id}`, this.auth()).then(r => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', {
                        msg: r.data.inativado ? r.data.mensagem : 'Sucesso! - Grupo excluído.',
                        type: 'success'
                    })
                    if (this.selecionado && this.selecionado.id === g.id) this.selecionado = null
                    this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        buscarUsuarios (termo) {
            if (!termo || termo.length < 2 || !this.selecionado) return

            this.buscando = true
            this.$axios.post(`${this.base()}/api/grupo-trabalho/usuarios-disponiveis/${this.selecionado.id}`,
                { termo: termo }, this.auth()).then(r => {
                this.usuarios = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        adicionarMembro () {
            if (!this.novoMembro || !this.selecionado) return

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/grupo-trabalho/membro-adicionar/${this.selecionado.id}`,
                { user_id: this.novoMembro, papel: this.novoPapel }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Membro adicionado.', type: 'success' })
                this.novoMembro = ''
                this.selecionar(this.selecionado)
            }).catch(e => { this.erro(e) })
        },

        removerMembro (m) {
            this.$msgbox.confirm(`Remover ${m.name} do grupo?`, 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(
                    `${this.base()}/api/grupo-trabalho/membro-remover/${this.selecionado.id}/${m.user_id}`,
                    this.auth()
                ).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Membro removido.', type: 'success' })
                    this.selecionar(this.selecionado)
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        }
    },
    components: {  }
}
</script>
<style scoped>
.rotulo  { display: block; font-size: 12px; color: #606266; text-transform: uppercase; margin-bottom: 6px; }
.painel  { border: 1px solid #EBEEF5; border-radius: 4px; padding: 12px; min-height: 220px; background: #fff; }
.meta    { color: #909399; font-size: 13px; }
.no      { display: flex; justify-content: space-between; width: 100%; padding-right: 8px; }
.acoes-no{ opacity: 0; transition: opacity .15s; }
.no:hover .acoes-no { opacity: 1; }
.inativo { color: #C0C4CC; }
</style>
